// noinspection DuplicatedCode

import { GlobalContext, isValidFunction, tr } from 'mmfintech-commons'
import { Button } from 'mmfintech-portal-commons'
import { type ReactNode, useContext } from 'react'
import './ConfirmationModal.scss'

interface Props {
  title?: string
  question: ReactNode
  onConfirm: () => void
  confirmCaption?: string
  buttonColor?:
    | 'primary'
    | 'secondary'
    | 'alternative'
    | 'round-primary'
    | 'round-secondary'
    | 'delete'
    | 'round-alternative'
}

function ConfirmationModal({ title, question, onConfirm, confirmCaption, buttonColor = 'secondary' }: Props) {
  const { modalHide } = useContext(GlobalContext)

  function handleConfirm() {
    modalHide()
    isValidFunction(onConfirm) && onConfirm()
  }

  return (
    <div data-test='confirmation-dialog-modal'>
      <div className='confirmation-modal__title'>
        {title || tr('PORTAL.COMPONENTS.CONFIRMATION_TITLE', 'Confirmation')}
      </div>
      <div className='confirmation-modal__content'>{question}</div>
      <div className='confirmation-modal__buttons'>
        <Button
          type='button'
          color='primary'
          onClick={handleConfirm}
          data-test='button-confirm'
          text={confirmCaption || tr('FRONTEND.BUTTONS.CONFIRM', 'Confirm')}
        />
        <Button
          type='button'
          color={buttonColor}
          onClick={modalHide}
          data-test='button-cancel'
          text={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
        />
      </div>
    </div>
  )
}

export default ConfirmationModal
